<offline-notice>
</offline-notice>

<progress-overlay #progressOverlay>
</progress-overlay>

@if (productDesignerService.config) {
  <div class="pap-mat-primary productdesigner"
    >
    <progress-navigation></progress-navigation>
    @if (!disableDesigner && currentProduct) {
      <div class="productdesigner-step"
        >
        @switch (progress.group) {
          @case (progressConstants.GROUP_COLLAGEDESIGNER) {
            <div>
              <collage-designer [designStepId]="progress.groupMember">
            </collage-designer>
          </div>
        }
        @case (progressConstants.GROUP_FEATURES) {
          <div>
            <feature-selection [featureGroupId]="progress.groupMember">
            </feature-selection>
          </div>
        }
        @case (progressConstants.GROUP_ADDITIONAL_PRODUCTS) {
          <div>
            <additional-products-selection></additional-products-selection>
          </div>
        }
      }
    </div>
  }
</div>
}

<error></error>
